import React, { useEffect } from 'react';
import { DownloadOutlined } from '@ant-design/icons';
import { useSelector, useDispatch } from 'react-redux';
import { message, Modal } from 'antd';
import PropTypes from 'prop-types';
import CsvForm from './CsvForm';
import { downloadFile } from '~/helpers/download';

export default function CsvModal({
  data,
  fileName,
  clearData,
  visible,
  enableTechExport,
  handleClose,
  handleSubmitNormal,
  handleSubmitTech,
}) {
  const loading = useSelector(state => state.loading);
  const dispatch = useDispatch();

  useEffect(() => {
    if (data) {
      downloadFile(fileName, data);
      dispatch(clearData());
    }
  }, [data, dispatch, clearData, fileName]);

  return (
    <Modal
      title="Escolha o tipo de exportação"
      visible={visible}
      onCancel={handleClose}
      cancelText="Cancelar"
      okText="Exportar"
      okButtonProps={{
        form: 'add-soluter-form',
        htmlType: 'submit',
        icon: <DownloadOutlined />,
      }}
      key="add-soluter-modal"
      confirmLoading={loading.isLoadingExport}
    >
      <CsvForm
        enableTechExport={enableTechExport}
        handleClose={handleClose}
        handleSubmitNormal={handleSubmitNormal}
        handleSubmitTech={handleSubmitTech}
        formId="add-soluter-form"
      />
    </Modal>
  );
}

CsvModal.propTypes = {
  data: PropTypes.string.isRequired,
  enableTechExport: PropTypes.bool.isRequired,
  visible: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  clearData: PropTypes.func.isRequired,
  handleSubmitNormal: PropTypes.func,
  handleSubmitTech: PropTypes.func,
  fileName: PropTypes.string,
};

CsvModal.defaultProps = {
  handleSubmitTech: () => {},
  handleSubmitNormal: () => {},
  fileName: 'file',
};
